<template>
    <div>
        <v-alert :color="notification.color" rounded="lg" class="notification">
            <span class="notification-text">{{ notification.message }}</span>
        </v-alert>
    </div>
</template>

<script>
    export default {
        props: ['notification'],
    };
</script>
<style scoped>
    .notification {
        position: fixed;
        z-index: 100;
        bottom: 100px;
        margin-left: 5%;

        width: 100%;
        border-radius: 1px;
    }
    .notification-text {
        font-family: Bariol;
        font-style: normal;
        font-weight: bold;

        color: white;
    }
</style>
